import React, {useState} from 'react'
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import { logIn } from '../../services/actions/LoginAction';
import Loader from '../components/Loader';

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [data, setData] = useState({
        email: '',
        password: ''
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        e.preventDefault();
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {            
            await dispatch(logIn(data, navigate));
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text: 'Login failed. Please try again.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <div className="global-container">
                <div className="card-full login-form">
                    <div className="card-body">
                        <h3>Login</h3>
                        <div className="card-text">
                            <form onSubmit={handleSubmit} id="admin_login">
                                <div className="form-group mb-4">
                                    <label htmlFor="email">Email Address</label>
                                    <input type="email" name="email" id="email" value={data.email} onChange={handleChange} className="form-control valid"
                                        placeholder="Enter Email Address" />
                                    <label htmlFor="email" className="error w-100" ></label>
                                </div>
                                <div className="form-group mb-4 position-relative">
                                    <label htmlFor="password-field">Password</label>
                                    <i toggle="#password-field" className="fa fa-fw fa-eye-slash field-icon password-eye toggle-password"></i>
                                    <input type="password" name="password" maxLength="16" id="password-field" value={data.password} onChange={handleChange} className="form-control valid" placeholder="Enter Password" />
                                    <label htmlFor="password-field" className="error w-100"></label>
                                </div>
                                <button type="submit" className="btn mt-4 login-btn">Login</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Login